import { useScopedI18n, useCurrentLocale } from '@locales/client';
import { BonusFilters, BonusList, FilterButton } from '../styles';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { Condition } from '@/shared/ui/condition/condition';
import { BonusItemComponent } from '@/flat-pages/bonuses/ui/bonus-item/bonus-item';
import { BonusNotFound } from '@/flat-pages/bonuses/ui/bonus-not-found';

interface BonusListSectionProps {
  visibleFilters: { category: string; key: string }[];
  selectedTag: string | null;
  onFilterClick: (filter: string, index: number) => void;
  data: any[] | undefined;
  updateDate: () => Promise<void>;
  onBonusClick: (bonus: any) => void;
}

export const BonusListSection = ({
  visibleFilters,
  selectedTag,
  onFilterClick,
  data,
  updateDate,
  onBonusClick,
}: BonusListSectionProps) => {
  const tFilters = useScopedI18n('bonus.card.filters');
  const locale = useCurrentLocale();

  return (
    <>
      <Condition match={data?.length > 0}>
        <BonusFilters>
          {visibleFilters.map((filter, index) => (
            <FilterButton
              key={filter.category}
              $isActive={
                selectedTag === filter.category ||
                (index === 0 && selectedTag === null)
              }
              onClick={() => onFilterClick(filter.category, index)}
            >
              <BodyTextMediumC>{tFilters(filter.key)}</BodyTextMediumC>
            </FilterButton>
          ))}
        </BonusFilters>
        <BonusList>
          {data?.map((bonus) => (
            <BonusItemComponent
              key={bonus?.userBonusId || bonus?.id}
              bonus={bonus}
              onClickHandler={() => onBonusClick(bonus)}
              locale={locale}
              updateDate={updateDate}
              isCarousel={false}
            />
          ))}
        </BonusList>
      </Condition>

      <Condition match={data?.length === 0}>
        <BonusNotFound />
      </Condition>
    </>
  );
};
